// https://vuex.vuejs.org/en/state.html

export default {
  status: state => state.status,
  medias: state => state.medias,
  media: state => state.product,
  marketplaces: state => state.marketplaces,
};
